import { render, staticRenderFns } from "./employeeCode.vue?vue&type=template&id=4822f9f8&"
import script from "./employeeCode.vue?vue&type=script&lang=js&"
export * from "./employeeCode.vue?vue&type=script&lang=js&"
import style0 from "./employeeCode.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../viewport/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports